export default __webpack_public_path__ + "static/media/food.f77d62ab.png";